import { Directive, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[numbersOnly]'
})
export class OnlynumberDirective {
  @Input("numbersOnly") mystyle: any;

  constructor(private el: ElementRef) {
    el.nativeElement.onkeypress = function (e) {
      if (e.which === 8 || e.which === 0) {
        return true;
      }

      const regex = new RegExp("^[0-9\~]*$");
      var key = String.fromCharCode(!e.charCode ? e.which : e.charCode);
      if (!regex.test(key)) {
        e.preventDefault();
        return false;
      }
      return true;
    };
  }

}
